import { useQuery } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * Fetch saved posts, optionally filtered by collection name.
 * @param {string} userId
 * @param {boolean} enabled
 * @param {string|null} collection - collection name to filter by (null = all)
 */
export const useSavedPostsQuery = (userId, enabled = true, collection = null) => {
  return useQuery({
    queryKey: ["savedPosts", userId, collection],
    queryFn: async () => {
      const params = { limit: 50 };
      if (collection) params.collection = collection;
      const res = await api.get("/posts/saved", { params });
      return res.data.posts || [];
    },
    enabled: enabled && !!userId,
    staleTime: 30_000,
  });
};
